import type { QueryClient } from '@tanstack/react-query'
import { notFound } from '@tanstack/react-router'

import { meQueryOptions } from '@/shared/auth/session'

import { can, type Permission } from './permissions'

/**
 * beforeLoad para rotas de módulo: esconde a tela (404) de quem não tem a
 * permissão. A API continua sendo a autoridade (403 nas Policies).
 *
 * @example
 * createRoute({ ..., beforeLoad: requirePermission('users.view') })
 */
export function requirePermission(permission: Permission) {
  return async ({ context }: { context: { queryClient: QueryClient } }): Promise<void> => {
    const admin = await context.queryClient.ensureQueryData(meQueryOptions)

    if (!can(admin, permission)) {
      throw notFound()
    }
  }
}
